/**
 * Utility to get contextually appropriate messages when editing is blocked
 * by various workflow states (archived, archival in progress, protocol locked, runs exist)
 */

export interface EditBlockedState {
  isArchived?: boolean;
  isArchivalInProgress?: boolean;
  isProtocolLocked?: boolean;
  isLifecycleLocked?: boolean;
  runsExist?: boolean;
  canEditContent?: boolean;
}

/**
 * Get appropriate warning message based on workflow state
 * Returns the first applicable message in priority order
 */
export function getEditBlockedMessage(state: EditBlockedState): string {
  if (state.isArchived) {
    return 'This workflow is archived and cannot be edited.';
  }
  if (state.isArchivalInProgress) {
    return 'This workflow is being archived and cannot be edited.';
  }
  if (state.isProtocolLocked) {
    return 'Protocol is locked. Unlock it to make changes.';
  }
  if (state.isLifecycleLocked) {
    return 'Workflow is locked by lifecycle rules. Save as new version to edit.';
  }
  if (state.runsExist) {
    return 'Save as new version to edit!';
  }
  if (state.canEditContent === false) {
    return 'Editing is disabled in the current lifecycle status.';
  }
  return 'Cannot edit workflow at this time.';
}

/**
 * Determine if editing is blocked for any reason
 */
export function isEditingBlocked(state: EditBlockedState): boolean {
  return !!(
    state.isArchived ||
    state.isArchivalInProgress ||
    state.isProtocolLocked ||
    state.isLifecycleLocked ||
    state.runsExist ||
    state.canEditContent === false
  );
}
